@if (active) {
    <div class="row">
        <div class="col-xs-12 mgb10 annotation-tool-title">
            {{tool.title}}
        </div>
        <div class="col-xs-12 annotation-tool-body">
            @if (showErrors()) {
                <div class="annotation-tool-errors">
                    <div class="panel panel-default">
                        <div
                            class="panel-heading"
                            (click)="tool.showErrors = !tool.showErrors">
                            <span>Errors</span>
                            <span class="badge">{{tool.errors.length}}</span>
                            <i
                                class="nlrp-icon"
                                [ngClass]="tool.showErrors ? 'nlrp-icon-up-chevron':'nlrp-icon-down-chevron'"></i>
                        </div>
                        @if (tool.showErrors) {
                            <div class="panel-body">
                                @for (error of tool.errors; track error) {
                                    <div>
                                        {{error}}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
            @if (tool.warnings && tool.warnings.length > 0) {
                <div class="annotation-tool-warnings">
                    <div class="panel panel-default">
                        <div
                            class="panel-heading"
                            (click)="tool.showWarnings = !tool.showWarnings">
                            <span>Warnings</span>
                            <span class="badge">{{tool.warnings.length}}</span>
                            <i
                                class="nlrp-icon"
                                [ngClass]="tool.showWarnings ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"></i>
                        </div>
                        @if (tool.showWarnings) {
                            <div class="panel-body">
                                @for (warning of tool.warnings; track warning) {
                                    <div>{{warning}}</div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
            @if (tool.information && tool.information.length > 0) {
                <div class="annotation-tool-information">
                    <div class="panel panel-default">
                        <div
                            class="panel-heading"
                            (click)="tool.showInformation = !tool.showInformation">
                            <span>Information</span>
                            <span class="badge">{{tool.information.length}}</span>
                            <i
                                class="nlrp-icon"
                                [ngClass]="tool.showInformation ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"></i>
                        </div>
                        @if (tool.showInformation) {
                            <div class="panel-body">
                                @for (info of tool.information; track info) {
                                    <div>{{info}}</div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
            @if (showAttribute()) {
                <div class="col-xs-12 p0 mgb10">
                    <label
                        class="control-label"
                        for="{{tool.type + 'annotationType'}}">
                        Annotation Type
                    </label>
                    <ng-select
                        class="nlr-ng-select"
                        [searchable]="false"
                        [clearable]="false"
                        [id]="tool.type + 'annotationType'"
                        [name]="tool.type + 'annotationType'"
                        [disabled]="tool.type === 'edit'"
                        placeholder="Select"
                        [items]="annotationTypes"
                        bindLabel="description"
                        [ngModel]="selectedAnnotationType"
                        (change)="changeSelectedAnnotationType($event)">
                    </ng-select>
                </div>
            }
            @if (showAttribute()) {
                <div>
                    @for (attribute of attributes.sort(compareEditableOrderToolsWidget); track attribute; let i = $index) {
                        <div>
                            @if (attribute.attributeType === 'DOMAIN') {
                                <div class="col-xs-12 p0 mgb10">
                                    <label
                                        class="control-label"
                                        [ngClass]="{'required-input': isRequired(attribute.prop)}"
                                        for="{{tool.type + attribute.prop}}">
                                        {{attribute.name}}:
                                    </label>
                                    <ng-select
                                        class="nlr-ng-select"
                                        [searchable]="false"
                                        [clearable]="false"
                                        [id]="tool.type + attribute.prop"
                                        [name]="tool.type + attribute.prop"
                                        [disabled]="isDisabled(attribute.prop)"
                                        title="Select {{attribute.name}}"
                                        placeholder="Select"
                                        [items]="attribute.values"
                                        bindLabel="description"
                                        [ngModel]="attribute"
                                        (change)="changeSelectedAttribute(attribute, $event)">
                                    </ng-select>
                                </div>
                            }
                            @if (attribute.attributeType === 'BOOLEAN') {
                                <div
                                    class="col-xs-12 p0 mgb10"
                                    [ngClass]="{'has-error': hasError(tool.type + attribute.prop)}">
                                    <div
                                        class="checkbox mg0 l130"
                                        title="{{attribute.name}}">
                                        <div class="checkbox-inline">
                                            <i
                                                class="nlrp-icon"
                                                [ngClass]="{'nlrp-icon-check-box-selected' : attribute.value, 'nlrp-icon-check-box-unselected': !attribute.value}"
                                                (click)="attribute.value = !attribute.value"></i>
                                            <input
                                                type="checkbox"
                                                id="{{tool.type + attribute.prop}}"
                                                #checkBoxField="ngModel"
                                                [name]="tool.type + attribute.prop"
                                                [(ngModel)]="attribute.value"
                                                [required]="isRequired(attribute.prop)"
                                                [readonly]="isDisabled(attribute.prop)"
                                                style="visibility: hidden;" />
                                        </div>
                                    </div>
                                    <label
                                        class="checkbox-label"
                                        for="{{tool.type + attribute.prop}}">
                                        {{attribute.name}}
                                    </label>
                                    @if (!checkBoxField.errors?.required && (checkBoxField | formFieldHasError)) {
                                        <div class="help-block">
                                            <span>Error!</span>
                                            <span>{{attribute.name}} value is invalid.</span>
                                        </div>
                                    }
                                </div>
                            }
                            @if (attribute.attributeType === 'RADIO') {
                                <div
                                    class="col-xs-12 p0 mgb10"
                                    [ngClass]="{'has-error': hasError(tool.type + attribute.prop)}">
                                    <label
                                        class="control-label"
                                        [ngClass]="{'required-input': isRequired(attribute.prop)}"
                                        for="{{tool.type + attribute.prop}}">
                                        {{attribute.name}}:
                                    </label>
                                    @for (option of attribute.values; track option; let isLast = $last) {
                                        <label
                                            class="nlr-radio"
                                            title="Select {{attribute.name}}">
                                            <input
                                                type="radio"
                                                #radioInputField="ngModel"
                                                [name]="tool.type + attribute.prop"
                                                id="{{tool.type + attribute.prop}}"
                                                [value]="option.value"
                                                [(ngModel)]="attribute.value"
                                                [readonly]="isDisabled(attribute.prop)"
                                                [required]="isRequired(attribute.prop)" />
                                            <span>{{option.description}}</span>
                                            @if (isLast && !radioInputField.errors?.required && (radioInputField | formFieldHasError)) {
                                                <div class="help-block">
                                                    <span>Error!</span>
                                                    <span>{{attribute.name}} value is invalid.</span>
                                                </div>
                                            }
                                        </label>
                                    }
                                </div>
                            }
                            @if (attribute.attributeType?.includes('STRING') && attribute.dms && attribute.attributeTypeLength <= 20) {
                                <div
                                    class="col-xs-12 p0 mgb10"
                                    [ngClass]="{'has-error': hasError(tool.type + attribute.prop)}">
                                    <label
                                        class="control-label"
                                        [ngClass]="{'required-input': isRequired(attribute.prop)}"
                                        for="{{tool.type + attribute.prop}}">
                                        {{attribute.name}}:
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <i class="nlrp-icon nlrp-icon-edit"></i>
                                        </span>
                                        <input
                                            type="text"
                                            class="form-control text-uppercase"
                                            id="{{tool.type + attribute.prop}}"
                                            #inputTextField="ngModel"
                                            [name]="tool.type + attribute.prop"
                                            [(ngModel)]="attribute.value"
                                            [required]="isRequired(attribute.prop)"
                                            [maxLengthInputLimit]="attribute.attributeTypeLength"
                                            [placeholder]="attribute.placeholder"
                                            [readonly]="isDisabled(attribute.prop)"
                                            nlrAnglePattern
                                            (focus)="onFocus()"
                                            (blur)="onBlur()"
                                            title="Enter {{attribute.name}}"
                                            autocomplete="off" />
                                    </div>
                                    @if (!inputTextField.errors?.required && (inputTextField | formFieldHasError)) {
                                        <div class="help-block">
                                            <span>Invalid!</span>
                                            <span>Enter value in D.MMSS format: D=0-359, MM=00-59, SS=00-59</span>
                                        </div>
                                    }
                                </div>
                            }
                            @if (attribute.attributeType?.includes('STRING') && !attribute.dms && attribute.attributeTypeLength <= 20) {
                                <div
                                    class="col-xs-12 p0 mgb10"
                                    [ngClass]="{'has-error': hasError(tool.type + attribute.prop)}">
                                    <label
                                        class="control-label"
                                        [ngClass]="{'required-input': isRequired(attribute.prop)}"
                                        for="{{tool.type + attribute.prop}}">
                                        {{attribute.name}}:
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <i class="nlrp-icon nlrp-icon-edit"></i>
                                        </span>
                                        <input
                                            type="text"
                                            class="form-control text-uppercase"
                                            id="{{tool.type + attribute.prop}}"
                                            #inputTextField1="ngModel"
                                            [name]="tool.type + attribute.prop"
                                            [(ngModel)]="attribute.value"
                                            [required]="isRequired(attribute.prop)"
                                            [maxlength]="attribute.attributeTypeLength"
                                            [placeholder]="attribute.placeholder"
                                            [readOnly]="isDisabled(attribute.prop)"
                                            [nlrPattern]="attribute.pattern"
                                            title="Enter {{attribute.name}}"
                                            nlrUppercase
                                            autocomplete="off" />
                                    </div>
                                    @if (!inputTextField1.errors?.required && (inputTextField1 | formFieldHasError)) {
                                        <div class="help-block">
                                            <span>Error!</span>
                                            <span>{{attribute.name}} value is invalid.</span>
                                        </div>
                                    }
                                </div>
                            }
                            @if (attribute.attributeType?.includes('STRING') && attribute.attributeTypeLength > 20) {
                                <div
                                    class="col-xs-12 p0 mgb10"
                                    [ngClass]="{'has-error': hasError(tool.type + attribute.prop)}">
                                    <label
                                        class="control-label"
                                        [ngClass]="{'required-input': isRequired(attribute.prop)}"
                                        for="{{tool.type + attribute.prop}}">
                                        {{attribute.name}}:
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-addon corner"><i class="nlrp-icon nlrp-icon-edit corner-icon"></i></span>
                                        <textarea
                                            class="form-control text-uppercase"
                                            id="{{tool.type + attribute.prop}}"
                                            #inputFieldTextArea="ngModel"
                                            [name]="tool.type + attribute.prop"
                                            [(ngModel)]="attribute.value"
                                            [required]="isRequired(attribute.prop)"
                                            [maxLengthInputLimit]="attribute.attributeTypeLength"
                                            [placeholder]="attribute.placeholder"
                                            [readOnly]="isDisabled(attribute.prop)"
                                            [nlrPattern]="attribute.pattern"
                                            title="Enter {{attribute.name}}"
                                            rows="4">
                                        </textarea>
                                    </div>
                                    @if (!inputFieldTextArea.errors?.required && (inputFieldTextArea | formFieldHasError)) {
                                        <div class="help-block">
                                            <span>Error!</span>
                                            <span>{{attribute.name}} value is invalid.</span>
                                        </div>
                                    }
                                </div>
                            }
                            @if (attribute.attributeType?.includes('INTEGER')) {
                                <div
                                    class="col-xs-12 p0 mgb10"
                                    [ngClass]="{'has-error': hasError(tool.type + attribute.prop)}">
                                    <label
                                        class="control-label"
                                        [ngClass]="{'required-input': isRequired(attribute.prop)}"
                                        for="{{tool.type + attribute.prop}}">
                                        {{attribute.name}}:
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <i class="nlrp-icon nlrp-icon-edit"></i>
                                        </span>
                                        <input
                                            type="number"
                                            class="form-control"
                                            id="{{tool.type + attribute.prop}}"
                                            #inputFieldNumber="ngModel"
                                            [name]="tool.type + attribute.prop"
                                            string-to-number
                                            [(ngModel)]="attribute.value"
                                            [required]="isRequired(attribute.prop)"
                                            maxlength="{{attribute.attributeTypeLength}}"
                                            placeholder="{{attribute.placeholder}}"
                                            [readonly]="isDisabled(attribute.prop)"
                                            title="Enter {{attribute.name}}" />
                                    </div>
                                    @if (!inputFieldNumber.errors?.required && (inputFieldNumber | formFieldHasError)) {
                                        <div class="help-block">
                                            <span>Error!</span>
                                            <span>{{attribute.name}} value is invalid.</span>
                                        </div>
                                    }
                                </div>
                            }
                            @if (attribute.attributeType?.includes('DECIMAL')) {
                                <div
                                    class="col-xs-12 p0 mgb10"
                                    [ngClass]="{'has-error': hasError(tool.type + attribute.prop)}">
                                    <label
                                        class="control-label"
                                        [ngClass]="{'required-input':isRequired(attribute.prop)}"
                                        for="{{tool.type + attribute.prop}}">
                                        {{attribute.name}}:
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <i class="nlrp-icon nlrp-icon-edit"></i>
                                        </span>
                                        <input
                                            type="number"
                                            class="form-control"
                                            id="{{tool.type + attribute.prop}}"
                                            #inputFieldNumber1="ngModel"
                                            [name]="tool.type + attribute.prop"
                                            [(ngModel)]="attribute.value"
                                            [required]="isRequired(attribute.prop)"
                                            placeholder="{{attribute.placeholder}}"
                                            title="Enter {{attribute.name}}"
                                            [readonly]="isDisabled(attribute.prop)"
                                            [nlrPattern]="attribute.pattern"
                                            step="0.01" />
                                    </div>
                                    @if (!inputFieldNumber1.errors?.required && (inputFieldNumber1 | formFieldHasError)) {
                                        <div class="help-block">
                                            <span>Error!</span>
                                            <span>{{attribute.name}} value is invalid.</span>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                    <!--            <div *ngIf="hasMinOptionalError()">-->
                    <!--                <input-->
                    <!--                    type="checkbox"-->
                    <!--                    [name]="minOptional"-->
                    <!--                    class="hidden"-->
                    <!--                    [(ngModel)]="minOptional"-->
                    <!--                    required />-->
                    <!--            </div>-->
                </div>
            }
        </div>
    </div>
}
